/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TellerUpdateInputDto { 
    name: string;
    userId: number;
    branchId: number;
    accountingCode?: string | null;
    accountingName?: string | null;
    maxWithdrawalLimitWithoutApproval?: number;
    maxDepositLimitWithoutApproval?: number;
    maxRepaymentLimitWithoutApproval?: number;
    maxDisbursementLimitWithoutApproval?: number;
    postPrincipalInterestAndPenaltySeprately?: boolean;
    allowsTransferToOtherTellers?: boolean;
    allowPostingOnBehalfOfOtherTellers?: boolean;
    id: number;
}

